import {
    buildConfigSliceWithGridSupport,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import {
    getInitialEstimatedTradeCostComparisonConfigState,
    EstimatedTradeCostComparisonConfigState,
} from './EstimatedTradeCostComparisonConfigState';
import { selectEstimatedTradeCostComparisonWidgetState } from './selectors';

export const buildEstimatedTradeCostComparisonWidgetConfigSlice = () =>
    buildConfigSliceWithGridSupport(
        WidgetType.EST_TRADE_COST_COMPARISON_WIDGET,
        selectEstimatedTradeCostComparisonWidgetState,
        getInitialEstimatedTradeCostComparisonConfigState()
    );

export const useEstimatedTradeCostComparisonWidgetConfigSlice = () =>
    useConfigSlice(buildEstimatedTradeCostComparisonWidgetConfigSlice());

export type EstimatedTradeCostComparisonConfigPayloadType =
    WidgetConfigSliceActionPayloadType<EstimatedTradeCostComparisonConfigState>;
